import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

const antropometryApi = createApi({
  reducerPath: 'antropometry',
  tagTypes: ['Antropometry'],
  baseQuery,
  endpoints(builder) {
    return {
      fetchAntropometrys: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Antropometry', id: 'LIST' },
                ...result.map((r) => ({ type: 'Antropometry', id: r.id })),
              ]
            : [{ type: 'Antropometry', id: 'LIST' }],
        query: () => ({
          url: `?resource=antropometry&order=created_at.asc`,
          method: 'GET',
        }),
      }),

      fetchAntropometry: builder.query({
        providesTags: (result, error, arg) => [{ type: 'Antropometry', id: arg }],
        query: (antropometryId) => ({
          url: `?resource=antropometry&id=eq.${antropometryId}`,
          method: 'GET',
        }),
      }),

      fetchAntropometryByAthleteId: builder.query({
        providesTags: (result) =>
          result
            ? [
                { type: 'Antropometry', id: 'LIST' },
                ...result.map((r) => ({ type: 'Antropometry', id: r.id })),
              ]
            : [{ type: 'Antropometry', id: 'LIST' }],
        query: (athleteId) => ({
          url: `?resource=antropometry&athlete=eq.${athleteId}&order=created_at.desc`,
          method: 'GET',
        }),
      }),

      createAntropometry: builder.mutation({
        invalidatesTags: [{ type: 'Antropometry', id: 'LIST' }],
        query: (data) => ({
          url: `?resource=antropometry`,
          method: 'POST',
          body: data,
        }),
      }),

      updateAntropometry: builder.mutation({
        invalidatesTags: (result, error, { id: antropometryId }) => [
          { type: 'Antropometry', id: antropometryId },
          { type: 'Antropometry', id: 'LIST' },
        ],
        query: ({ id: antropometryId, submitData }) => ({
          url: `?resource=antropometry&id=eq.${antropometryId}`,
          method: 'PATCH',
          body: submitData,
        }),
      }),
    };
  },
});

export const {
  useFetchAntropometrysQuery,
  useFetchAntropometryQuery,
  useFetchAntropometryByAthleteIdQuery,
  useCreateAntropometryMutation,
  useUpdateAntropometryMutation,
} = antropometryApi;

export { antropometryApi };
